import { FC } from 'react'
import { useLocation } from 'wouter'
import clx from '../util/clx'
import formatTime from '../util/formatTime'
import StarIcon from './Icon/StarIcon'

type Props = {
	puzzleNumber: number
	puzzleDate: string
	score: number
	time?: number
}

const ArchiveCardShine = () => {
	return (
		<svg
			className="archive-card__shine"
			width="95"
			height="106"
			viewBox="0 0 95 106"
			preserveAspectRatio="none"
		>
			<path d="M95 0H48.7611L0 106H46.2389L95 0Z" fill="white" fillOpacity="0.3" />
		</svg>
	)
}

const ArchiveCard: FC<Props> = props => {
	const { puzzleNumber, puzzleDate, score, time } = props
	const [, navigate] = useLocation()
	const formattedPuzzleDate = new Date(puzzleDate).toDateString()
	const shortPuzzleDate = new Date(puzzleDate).toLocaleDateString().substring(0, 5)
	const formattedTime = formatTime(time ?? 0)

	const cl = clx('archive-card', {
		'archive-card--gold': score === 5,
	})

	const archiveTimeCl = clx('archive-card__time', {
		'archive-card__time--hidden': time === undefined,
	})

	return (
		<button className={cl} onClick={() => navigate(`/archive/daily/${puzzleNumber}`)}>
			<div className="archive-card__meta">
				<span className="archive-card__number">#{props.puzzleNumber}</span>
				<span className="archive-card__date archive-card__date--long">
					{formattedPuzzleDate}
				</span>
				<span className="archive-card__date archive-card__date--short">
					{shortPuzzleDate}
				</span>
			</div>
			<div className="archive-card__stars">
				<StarIcon filled={score >= 1} />
				<StarIcon filled={score >= 2} />
				<StarIcon filled={score >= 3} />
				<StarIcon filled={score >= 4} />
				<StarIcon filled={score === 5} />
			</div>
			<div className={archiveTimeCl}>{formattedTime}</div>
			{score === 5 && (
				<div className="archive-card__shine-group">
					<ArchiveCardShine />
					<ArchiveCardShine />
				</div>
			)}
		</button>
	)
}

export default ArchiveCard
